// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TypeAndPrice_wrapper__IugKv","type-url":"TypeAndPrice_type-url__wCkX9"};